<h2 class="heading-4">How to claim</h2>

<p class="body mt-16">
  With Argos Replacement Care, you can make a claim by visiting any Argos store. (Other Argos Care plans might work
  differently, so check your plan's terms and conditions.)
</p>

<p class="body mt-8">You'll need to bring:</p>

<ul>
  <li class="body">The product</li>
  <li class="body">Your product receipt</li>
  <li class="body">Your Argos Replacement Care receipt</li>
</ul>
